/* eslint-disable import/no-anonymous-default-export */
//const { ipcRenderer } = window.require('electron');
//const electron = window.require('electron')
// import $ from "jquery";
export default {
  parseJwt(token) {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  },
  sessionGuard() {
    // const cookies = new Cookies();
    if (!localStorage.getItem("FuelFy@daisy")) {
      //window.location='/login';
      return false;
    } else {
      const access_token = localStorage.getItem("FuelFy@daisy");
      const decorded_token = this.parseJwt(access_token);
      // console.log(decorded_token["data"]["user_id"]);
      return Number(decorded_token["data"]["user_id"]);
    }
  },
  role_idGuard() {
    // const cookies = new Cookies();
    if (!localStorage.getItem("FuelFy@daisy")) {
      //window.location='/login';
      return false;
    } else {
      const access_token = localStorage.getItem("FuelFy@daisy");
      const decorded_token = this.parseJwt(access_token);
      return decorded_token["data"]["role_id"];
    }
  },
  readPermissions() {
    if (localStorage.getItem("FuelFy@daisy")) {
      const access_token = localStorage.getItem("FuelFy@daisy");
      const decorded_token = this.parseJwt(access_token);
      return decorded_token["data"]["permissions"]["list"];
    } else {
      return false;
    }
  },
  readUser() {
    if (localStorage.getItem("FuelFy@daisy")) {
      const access_token = localStorage.getItem("FuelFy@daisy");
      const decorded_token = this.parseJwt(access_token);
      return decorded_token["data"];
    } else {
      return false;
    }
  },
  checkSecureAccount() {
    if (localStorage.getItem("FuelFy@daisy")) {
      const access_token = localStorage.getItem("FuelFy@daisy");
      const decorded_token = this.parseJwt(access_token);
      return decorded_token["data"]["is_secure"];
    } else {
      return "UNLOGGED";
    }
  },
  db_date(objDate) {
    const month = (objDate.getMonth() + 1).toString();
    const newMonth = month.length === 1 ? "0" + month : month;
    const day = objDate.getDate().toString();
    const newDay = day.length === 1 ? "0" + day : day;
    const newDate =
      objDate.getFullYear().toString() + "-" + newMonth + "-" + newDay;
    return newDate;
  },
  uCfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  findInObject(object, value) {
    for (var i = 0; i < object.length; i++) {
      var exists = object[i].code === value;
      if (exists) {
        return true;
      }
    }
    return false;
  },
  getHost() {
    switch (process.env.REACT_APP_ENVIRONMENT) {
      case "PRODUCTION":
        return process.env.REACT_APP_PRODUCTIONURL;
      case "TEST":
        return process.env.REACT_APP_TESTURL;
      default:
        return process.env.REACT_APP_DEVELOPMENTURL;
    }
  },
  getCaptiveHost() {
    switch (process.env.REACT_APP_ENVIRONMENT) {
      case "PRODUCTION":
        return process.env.REACT_APP_PRODUCTIONURL;
      case "TEST":
        return process.env.REACT_APP_TESTURL;
      default:
        return process.env.REACT_APP_DEVELOPMENTURL;
    }
  },
};
